import {NestApiProvider} from "../../nest-api";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";

@Injectable()
export class SfApprovalSettingApiNest {
    private service: string = '';
    private model: string = 'sFApprovalSetting';

    constructor(
        public nestApiProvider: NestApiProvider
    ) {
    }

    getListing():Observable<any>{
        const method: string = 'POST';
        const func: string = 'getListing';
        const params: any = {};
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
    }

    getApprovalList():Observable<any>{
        const method: string = 'GET';
        const func: string = 'getApprovalList';
        const params: any = {};
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request(method, url, func, params, body);
    }

    save(data: any):Observable<any>{
        const method: string = 'POST';
        const func: string = 'save';
        const params: any = data || {};
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
    }



}


// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/sf-approval-setting.api.ts